import { atom, useAtomValue, getDefaultStore } from "jotai";

/**
 * 跨功能页面 URL 记忆。
 * key = 功能首段路径（如 "kb"、"doc-center"），value = 完整 href（path + search + hash）。
 * 纯内存 atom：刷新页面即重置；组件卸载不重置（跨功能切换时保留）。
 */
const navMemoryAtom = atom<Record<string, string>>({});

/** 从路径提取功能 key（首段）。"/kb/123" → "kb"，"/doc-center" → "doc-center" */
export function getFeatureKey(pathname: string): string | null {
  return pathname.split("/").filter(Boolean)[0] ?? null;
}

/** 供 router.subscribe 回调使用：记录一次导航 */
export function recordNavMemory(pathname: string, href: string): void {
  const featureKey = getFeatureKey(pathname);
  if (!featureKey) return;
  getDefaultStore().set(navMemoryAtom, (prev) =>
    prev[featureKey] === href ? prev : { ...prev, [featureKey]: href },
  );
}

/** sidebar 组件用：订阅记忆 Map */
export function useNavMemory(): Record<string, string> {
  return useAtomValue(navMemoryAtom);
}
